module.exports = __webpack_public_path__ + "img/h5_block03.07396628.webp";